const lang = {
  contact: 'Contatti',
  experience: 'Esperienza professionale',
  education: 'Formazione',
  skills: 'Competenze',
  about: 'Su di me'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/it.js